module.exports = __webpack_public_path__ + "media/components/assets/img/bg/cloud-airplane-flyo-7350a7986aac3f4a6277cf44d9e4bf1f.svg";